<template>
    <b-container>
        <h3>USER UPDATE</h3>
        <div class="alert-info">
            <p class="p-2">Use this form to update a user</p>
        </div>
        <b-row>
            <b-col>
                <b-form-group id="input-group-2" label="Username" label-for="input-2">
                    <b-form-input
                    id="input-2"
                    v-model="username"
                    placeholder="Enter name"
                    required
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group id="input-group-2" label="Email" label-for="input-2">
                    <b-form-input
                    id="input-2"
                    v-model="email"
                    placeholder="Email"
                    required
                    ></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-radio-group
                :value="active"
                v-model="active"
                @change="updateUserStatus()"
                class="mt-4"
                >
                <b-form-radio :value="true">True</b-form-radio>
                <b-form-radio :value="false">False</b-form-radio>
                </b-form-radio-group>
            </b-col>
            <b-col>
                <b-form-group id="input-group-2" label="User type" label-for="input-2">
                    <b-form-input
                    id="input-2"
                    v-model="userType"
                    disabled
                    ></b-form-input>
                </b-form-group>
            </b-col>
             <div class="w-100"></div>
             <b-button class="info ml-3" @click="updateUser">Update User</b-button>
             <div class="w-100"></div>
             <b-form-checkbox
                id="checkbox-1"
                v-model="status"
                name="checkbox-1"
                value=true
                unchecked-value=false
                class="mt-4 mb-5"
            >
                Change Password
            </b-form-checkbox>
        </b-row>
        <b-row v-if="status=='true'">
            <b-col>
                <b-form-group id="input-group-2" label="Password" label-for="input-2">
                    <b-form-input
                    id="input-2"
                    v-model="password"
                    type="password"
                    required
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group id="input-group-2" label="Confirm Password" label-for="input-2">
                    <b-form-input
                    id="input-2"
                    v-model="confirm_pass"
                    type="password"
                    required
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <div class="w-100"></div>
            <p v-if="isPasswordCorrect">Password do not match</p>
            <p v-if="passworLength">Your password must be longer than 5 characters</p>
            <b-button @click="changePassword" class="info ml-3">Change Password</b-button>
        </b-row>

        
        
    </b-container>
</template>
<script>
import UserService from "@/services/UsersService";
import AuthService from "@/services/AuthService";
import router from "@/router";
import Swal from 'sweetalert2'
export default {
    name:"UserProfile",
    data(){
        return{
            username:"",
            userType:null,
            email:"",
            password:null,
            confirm_pass:null,
            active:false,
            userId:"",
            isPasswordCorrect:false,
            passworLength:false,
            status: false
        }
    },
    methods:{
        async getUser(){
            this.userId = router.currentRoute.params.id;
            this.userType = router.currentRoute.params.type;

            var userData = await UserService.getUser(this.userId);
            var user = userData.data.results[0];
            this.username = user.user_name;
            this.email = user.email;
            this.active = user.active;
            
        },
        async updateUser(){
            if(this.username != "" || this.email != ""){
                // Swal.fire({
                // title: 'Error!',
                // text: 'Do you want to continue',
                // icon: 'error',
                // confirmButtonText: 'Cool'
                // })
                 Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Update user!'
                    }).then(async (result) => {
                    if (result.isConfirmed) {
                       await UserService.updateUser(this.userId,{user_name:this.username,email:this.email,active:this.active})
                            .then((res)=>{
                                if(res.status == 200){
                                    Swal.fire(
                                    'Update!',
                                    'User has been updated.',
                                    'success'
                                    )
                                }else{
                                     Swal.fire(
                                    'Update!',
                                    'Failed to update user, try again later!',
                                    'error'
                                    )
                                }
                            }).catch((err)=>{
                                 Swal.fire(
                                    'Sorry :(',
                                    'Something went wrong, contact system Admin.',
                                    'error'
                                    )
                            })
                    }
                    })
            }
        },
        async changePassword(){
            if(this.password == this.confirm_pass){
                if(this.password.length >= 5){
                    this.isPasswordCorrect = false;
                    try{
                        
                         Swal.fire({
                            title: 'Are you sure?',
                            text: "You won't be able to revert this!",
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Yes, Update password!'
                            }).then(async (result) => {
                            if (result.isConfirmed) {
                            await AuthService.changePassword(this.userId,{password:this.password})
                                    .then((res)=>{
                                        if(res.status == 200){
                                            Swal.fire(
                                            'Password Update!',
                                            'User password has been changed.',
                                            'success'
                                            )
                                        }else{
                                            Swal.fire(
                                            'Password Update!',
                                            'Failed to update user password, try again later!',
                                            'error'
                                            )
                                        }
                                    }).catch((err)=>{
                                        Swal.fire(
                                            'Sorry :(',
                                            'Something went wrong, contact system Admin.',
                                            'error'
                                            )
                                    })
                            }
                            })
                    }catch(err){
                        console.log(err);
                    }
                }else{
                    this.passworLength = true;
                }
            }else{
                this.isPasswordCorrect = true;
            }
        }
    },
    created(){
        this.getUser();
    }
}
</script>